import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAe3FTV8Euw1AoxVltTQl5RWbvuTAQVguw",
  authDomain: "alfa-2026.firebaseapp.com",
  projectId: "alfa-2026",
  storageBucket: "alfa-2026.firebasestorage.app",
  messagingSenderId: "693791588908",
  appId: "1:693791588908:web:da5ecad515829880ccc789",
};

// Initialize Firebase y lo pongo en app
const app = initializeApp(firebaseConfig);

// getData devuelve la conexion con firestore a mi app
export const getData = () => getFirestore(app);
